import { render, staticRenderFns } from "./LegalAdviser.vue?vue&type=template&id=21096f0f&scoped=true&"
import script from "./LegalAdviser.vue?vue&type=script&lang=js&"
export * from "./LegalAdviser.vue?vue&type=script&lang=js&"
import style0 from "./LegalAdviser.vue?vue&type=style&index=0&id=21096f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21096f0f",
  null
  
)

export default component.exports